<div class="main-content">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <h4>{{projectDto.display_Name}}</h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <mat-tab-group dynamicHeight preserveContent animationDuration="0">
                            <mat-tab label="{{this.translate.data['PROJECTINFO'] | translate}}">
                                <ng-template matTabContent>
                                    <project-info [project]="projectDto"></project-info>
                                </ng-template>                                
                            </mat-tab> 
                            <mat-tab label="{{this.translate.data['PROJECTGROUPROLES'] | translate}}">
                                <ng-template matTabContent>
                                    <project-role [project]="projectDto"></project-role>                                    
                                </ng-template>                                
                            </mat-tab> 
                            <mat-tab label="{{this.translate.data['PROJECTUSERS'] | translate}}">
                                <ng-template matTabContent>
                                    <project-user [project]="projectDto"></project-user>                                    
                                </ng-template>                                
                            </mat-tab>                                                                                 
                            <mat-tab label="{{this.translate.data['APIINFO'] | translate}}">
                                <ng-template matTabContent>
                                    <project-api-info [project]="projectDto"></project-api-info>
                                </ng-template>                                
                            </mat-tab> 
                            <mat-tab label="Zusatzmodule">
                                <ng-template matTabContent>
                                    <project-contract-info [project]="projectDto"></project-contract-info>
                                </ng-template>                                
                            </mat-tab> 
                          </mat-tab-group>
                    </div>
                </div>               
                <!-- <div class="row">
                    <div class="col-md-12">
                        <button mat-mini-fab class="btn btn-squirrel pull-right" [routerLink]="['/manage-projects']"
                            queryParamsHandling="preserve" color="primary">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>

  